import React from "react";
import {
  Container,
  Paper,
  Typography,
  Button,
  Box
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import ContentWrapper from "../../../../common/components/contentWrapper";
import "../../../../common/style/main.css";
import MarkEmailReadOutlinedIcon from '@mui/icons-material/MarkEmailReadOutlined';
import { useLocation } from "react-router-dom";

const ForgotSuccess = () => {
  const history = useHistory();
  const location = useLocation();
  const email = location?.state?.email || "";

  const contentView = (
    <Container
      maxWidth="sm"
      style={{
            minHeight: "70vh", 
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        }}>
      <Paper style={{ padding: "30px", borderRadius: "10px" }}>
       <Box
         sx={{
              width: 62,
              height: 62,
              borderRadius: '50%',
              bgcolor: "rgb(66, 165, 245)",
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginLeft: "140px"
            }}
        >
        <MarkEmailReadOutlinedIcon
           color="primary"
           sx={{ fontSize: 36 }}
        />
        </Box>
        <p style={{ fontWeight: "bold", textAlign: "center", fontSize: "30px" }}>
          Email sent successfully!
        </p>

        <p style={{ marginTop: "10px", fontSize: "15px" }}>
          Password recovery link successfully sent to your email.
        </p>
        <p style={{ fontWeight: "bold", textAlign: "center", color: "#000", fontSize: "16px" }}>
         {email}
        </p>
        <p style={{ marginLeft: "10px", fontSize: "14px" }}>
            <strong>Note:</strong> The confirmation link will expire in <strong>7 days</strong>.
        </p>
        <Button
          variant="contained"
          style={{ marginTop: "20px", marginLeft: "100px"}}
          onClick={() => history.push("/login")}  
          className="SubmitColorSuccess"
        >
          Back to Login
        </Button>

      </Paper>
    </Container>
  );
  return <ContentWrapper contentView={contentView} />;
};

export default ForgotSuccess;
